<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznisilanlari from "@/models/mznisilanlari";
import Banner from "../components/banner";
import AddEdit from "./addedit.vue";
import Drawer from "vue-simple-drawer";
import formcombobox from "../formcomponet/formcombobox.vue";


export default {
  mixins: [apibtoast, apigeneric, mznisilanlari],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
    AddEdit,
    Drawer,
    formcombobox


  },
  data() {
    return {
      UserTur:null,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      DataUpdate: "",
      AddEdit: "",
      TableData: {},
      FirmaData:{},
      Filter: {
        Firmaadi: "",
        Calismasekli: "",
        Pozisyon: "",
        Tecrube: "",
        Istipi:"",
        Cinsiyet: "",
        Ehliyet: "",
        Egitimseviyesi: "",
        Askerlikdurumu: ""
      },
      FilitrelemePenceresi: false,
    };
  },
  validations: {
    Filter: {
      Firmaadi: {},
      Calismasekli: {},
      Pozisyon: {},
      Tecrube: {},
      Istipi:{},
      Cinsiyet: {},
      Ehliyet: {},
      Egitimseviyesi: {},
      Askerlikdurumu: {},
    },
  },
  methods: {
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    Get() {
         this.ActionsFilterGet({
                  Service: this.$config.API_URL_2 + "mznfirma",
                  Page: this.Page,
                  Filter: "&Userid=" + this.TokenUserId,
                }).then((responsefirma) => {
                  if (responsefirma.Data.length > 0) {
                    this.FirmaData= responsefirma.Data[0]
               
      let Filter =
        "&Firmaid=" +
        responsefirma.Data[0].Id +
        "&Firmaadi=" +
        this.Filter.Firmaadi +
        "&Calismasekli=" +
        this.Filter.Calismasekli +
        "&Pozisyon=" +
        this.Filter.Pozisyon +
        "&Tecrube=" +
        this.Filter.Tecrube +
        "&Istipi=" +
        this.Filter.Istipi +
        "&Cinsiyet=" +
        this.Filter.Cinsiyet +
        "&Ehliyet=" +
        this.Filter.Ehliyet +
        "&Askerlikdurumu=" +
        this.Filter.Askerlikdurumu+
        "&Egitimseviyesi=" +
        this.Filter.Egitimseviyesi  ;
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznisilanlari",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });

   } 
                });
    },
  },
  created(){
      
  }
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />
      <div class="graduates">  
        <div class="container">
          <div class="row">
                <div class="col-sm-12">
                  <div class="text-sm-end">
                       
                       <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.mznisilanlari
                      @click="(DataUpdate = mznisilanlariData), (AddEdit = 'Add')"
                    >
                      <i class="mdi mdi-plus me-1"></i
                      >{{ $t("mznisilanlari.Page.YeniKayitEkle") }}
                    </button>   
                  </div>
                  </div>
                  </div>
          <div class="table-graduate">
            <p class="h2 text-center cl-service-dark">İş İlanlarınız</p>
            <div class="container">
              <div class="search-bar" v-if="1 == 2">
                <div class="row c-flex">
                  <div class="col-md-3 l-flex" style = "top:6px;">
                    <div class="form-group full-width">
                     <formcombobox
                      :FormDataType="{
                        FieldName: 'Iş Tipi',
                        Field: 'input',
                        ComboDataArray: FormDataType.Istipi.ComboDataArray,
                      }"
                      :Value="Filter.Istipi"
                      :v="$v.Filter.Istipi"
                      @input="Filter.Istipi = $event"
                    />
                    </div>
                  </div>
                  <div class="col-md-3 l-flex" style = "top:6px;">
                    <div class="form-group full-width">
                      <formcombobox
                      :FormDataType="{
                        FieldName: 'Calismasekli',
                        Field: 'input',
                        ComboDataArray: FormDataType.Calismasekli.ComboDataArray,
                      }"
                      :Value="Filter.Calismasekli"
                      :v="$v.Filter.Calismasekli"
                      @input="Filter.Calismasekli = $event"
                      
                    />
                    </div>
                  </div>
                  <div class="col-md-3 l-flex" style = "top:6px;">
                    <div class="form-group full-width">
                     <formcombobox
                      :FormDataType="{
                        FieldName: 'Egitimseviyesi',
                        Field: 'input',
                        ComboDataArray: FormDataType.Egitimseviyesi.ComboDataArray,
                      }"
                      :Value="Filter.Egitimseviyesi"
                      :v="$v.Filter.Egitimseviyesi"
                      @input="Filter.Egitimseviyesi = $event"
                    />
                    </div>
                  </div>
                  <div class="col-md-1">
                    <button
                      type="button "
                      @click="Get()"
                      class="btn btn-dark full-width"
                    >
                      Ara
                    </button>
                  </div>
                  <div class="col-md-2 l-flex ">
                    <b-button
                      type="button"
                      class="btn btn-secondary btn-rounded full-width"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search"></i>
                      {{ $t("mznisilanlari.Page.GelismisFiltreleme") }}
                    </b-button>
                  
                  </div>
                </div>
              </div>

              <ul class="table-main">
                <li class="head bg-service">
                  <div class="row">
                    <div class="col-md-2">
                      <span class="order">{{
                        $t("mznisilanlari.Table.Istipivalue")
                      }}</span>
                    </div>
                    <div class="col-md-2">
                      <span>{{ $t("mznisilanlari.Table.Pozisyon") }}</span>
                    </div>
                    <div class="col-md-2">
                      <span>{{ $t("mznisilanlari.Table.Tecrube") }}</span>
                    </div>
                    <div class="col-md-2">
                      <span>{{ $t("mznisilanlari.Table.Egitimseviyesi") }}</span>
                    </div>
                    <div class="col-md-2">
                      <span>{{ $t("mznisilanlari.Table.Isintanimi") }}</span>
                    </div>
                    <div class="col-md-2">
                      <span>{{ $t("mznisilanlari.Table.Detay") }}</span>
                    </div>
                  </div>
                </li>
                <li v-for="(Data, index) in TableData" :key="index">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 l-flex">
                        <span class="order">{{ Data.Istipivalue }}</span>
                      </div>
                      <div class="col-md-2 l-flex">
                        <span class="profil-image">
                          {{ Data.Pozisyon }}
                        </span>
                      </div>
                      <div class="col-md-2 l-flex">
                        <span class="student-name">{{ Data.Tecrube }}</span>
                      </div>
                      <div class="col-md-2 l-flex">
                        <span>{{ Data.Egitimseviyesivalue }}</span>
                      </div>
                      <div class="col-md-2 l-flex">
                        <span>{{ Data.Isintanimi }}</span>
                      </div>
                      <div class="col-md-2 l-flex">
                          <b-button-group>
                          <b-button
                            variant="success"
                            v-b-modal.mznisilanlari
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                            ><i class="far fa-edit"></i
                          ></b-button>
                          <b-button
                            variant="danger"
                            @click="Delete('mznisilanlari', Data.Id)"
                            ><i class="far fa-trash-alt"></i
                          ></b-button>
                        </b-button-group>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
            <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()" :Firmaid="FirmaData.Id" />
      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("mznmezunlar.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("mznmezunlar.Filtreleme.Content") }}
            <div class="mb-3 mt-4">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Iş Tipi',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Istipi'),
                  ComboDataArray: FormDataType.Istipi.ComboDataArray,
                }"
                :Value="Filter.Istipi"
                :v="$v.Filter.Istipi"
                @input="Filter.Istipi = $event"
              />
            </div>
          <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Çalışma Şekli',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Calismasekli'),
                  ComboDataArray: FormDataType.Calismasekli.ComboDataArray,
                }"
                :Value="Filter.Calismasekli"
                :v="$v.Filter.Calismasekli"
                @input="Filter.Calismasekli = $event"
              />
            </div> 
        <!--    <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Cinsiyet',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Cinsiyet'),
                  ComboDataArray: FormDataType.Cinsiyet.ComboDataArray,
                }"
                :Value="Filter.Cinsiyet"
                :v="$v.Filter.Cinsiyet"
                @input="Filter.Cinsiyet = $event"
              />
            </div> -->
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Ehliyet',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Ehliyet'),
                  ComboDataArray: FormDataType.Ehliyet.ComboDataArray,
                }"
                :Value="Filter.Ehliyet"
                :v="$v.Filter.Ehliyet"
                @input="Filter.Ehliyet = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Askerlik Durumu',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Askerlikdurumu'),
                  ComboDataArray: FormDataType.Askerlikdurumu.ComboDataArray,
                }"
                :Value="Filter.Askerlikdurumu"
                :v="$v.Filter.Askerlikdurumu"
                @input="Filter.Askerlikdurumu = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Egitim Seviyesi',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Egitimseviyesi'),
                  ComboDataArray: FormDataType.Egitimseviyesi.ComboDataArray,
                }"
                :Value="Filter.Egitimseviyesi"
                :v="$v.Filter.Egitimseviyesi"
                @input="Filter.Egitimseviyesi = $event"
              />
            </div>
          

            <b-button
              @click="Get()"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("mznmezunlar.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
